export const ApiAdminLoginKey = 'ApiAdminLoginKey';
export const ApiAdminLogoutKey = 'ApiAdminLogoutKey';
export const ApiAdminCheckSessionKey = 'ApiAdminCheckSessionKey';
